import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';

const CustomerDetailsModal = ({ show, handleClose, content }) => {
  if (!content) return null;

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Customer Foreclosure Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table bordered className="mb-4">
          <tbody>
            <tr>
              <td width="35%" className="fw-semibold" style={{ backgroundColor: 'var(--slate-50)' }}>Member Name</td>
              <td className="fw-bold" style={{ color: 'var(--text-main)' }}>{content.memberName}</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ backgroundColor: 'var(--slate-50)' }}>Outstanding Amount</td>
              <td>₹{content.totalOutstandingAmount}</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ backgroundColor: 'var(--slate-50)' }}>Foreclose Charges (%)</td>
              <td>{Number(content.forecloseChargesPercentage ?? 0)}%</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ backgroundColor: 'var(--slate-50)' }}>Foreclose Charges Amount</td>
              <td>₹{content.forecloseChargesAmount}</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ backgroundColor: 'var(--slate-50)' }}>GST Amount (18%)</td>
              <td>₹{content.forecloseGstAmount}</td>
            </tr>
            <tr style={{ backgroundColor: '#F0F5FF' }}>
              <td className="fw-semibold" style={{ color: 'var(--primary-brand)' }}>Total Demand / Payable</td>
              <td className="fw-bold" style={{ color: 'var(--primary-brand)' }}>₹{content.totalPayableAmount}</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ backgroundColor: 'var(--slate-50)' }}>Security Deposit</td>
              <td>
                {content.isSecurityDepositAdjusted == null
                  ? "Not recorded"
                  : `₹${content.securityDepositAmount || 0} - ${content.isSecurityDepositAdjusted ? "Returned (deducted)" : "Not returned"}`}
              </td>
            </tr>
            <tr style={{ backgroundColor: '#F0F5FF' }}>
              <td className="fw-semibold" style={{ color: 'var(--primary-brand)' }}>Net Payable</td>
              <td className="fw-bold" style={{ color: 'var(--primary-brand)' }}>
                ₹{Math.max(0, Number(content.totalPayableAmount || 0) - (content.isSecurityDepositAdjusted ? Number(content.securityDepositAmount || 0) : 0))}
              </td>
            </tr>
            <tr style={{ backgroundColor: '#FEF2F2' }}>
              <td className="fw-semibold" style={{ color: '#991B1B' }}>Waiver Amount (Discount)</td>
              <td className="fw-bold" style={{ color: '#DC2626' }}>₹{content.waiverAmount || 0}</td>
            </tr>
            <tr style={{ backgroundColor: '#F0FDF4' }}>
              <td className="fw-semibold" style={{ color: '#166534' }}>Collected Cash Amount</td>
              <td className="fw-bold" style={{ color: '#16A34A' }}>
                ₹{content.collectedAmount ?? (Number(content.totalPayableAmount || 0) - Number(content.waiverAmount || 0))}
              </td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ backgroundColor: 'var(--slate-50)' }}>Reason</td>
              <td>{content.reason || "N/A"}</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ backgroundColor: 'var(--slate-50)' }}>Waiver Reason / Remarks</td>
              <td>{content.waiverReason || content.reason || "N/A"}</td>
            </tr>
          </tbody>
        </Table>

        <h5 className="mb-3" style={{ fontSize: '1rem', fontWeight: 700, color: 'var(--text-main)' }}>Cash Denominations</h5>
        <Table bordered>
          <thead>
            <tr style={{ backgroundColor: 'var(--primary-brand)', color: 'var(--white)' }}>
              <th style={{ textAlign: 'center' }}>Denomination</th>
              <th style={{ textAlign: 'center' }}>Count</th>
              <th style={{ textAlign: 'center' }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {content.denominations &&
              Object.entries(content.denominations)
                .sort(([a], [b]) => {
                  if (a === "Coins") return 1;
                  if (b === "Coins") return -1;
                  return parseInt(b) - parseInt(a);
                })
                .map(([denom, count]) => (
                  <tr key={denom}>
                    <td className="text-center fw-semibold">{denom}</td>
                    <td className="text-center">{count}</td>
                    <td className="text-center fw-bold">₹{denom === "Coins" ? count : parseInt(denom) * count}</td>
                  </tr>
                ))}
            <tr style={{ backgroundColor: '#F0FDF4' }}>
              <td colSpan="2" className="fw-bold ps-3" style={{ color: '#166534' }}>
                Collected Cash Total
              </td>
              <td className="text-center fw-bold" style={{ color: '#166534' }}>
                ₹{content.collectedAmount ?? (Number(content.totalPayableAmount || 0) - Number(content.waiverAmount || 0))}
              </td>
            </tr>
            {Number(content.waiverAmount) > 0 && (
              <tr style={{ backgroundColor: '#FEF2F2' }}>
                <td colSpan="2" className="fw-bold ps-3" style={{ color: '#991B1B' }}>
                  Waiver (Discount)
                </td>
                <td className="text-center fw-bold" style={{ color: '#DC2626' }}>
                  ₹{content.waiverAmount}
                </td>
              </tr>
            )}
            <tr style={{ backgroundColor: '#F0F5FF' }}>
              <td colSpan="2" className="fw-bold ps-3" style={{ color: 'var(--primary-brand)' }}>
                Total Demand Amount
              </td>
              <td className="text-center fw-bold" style={{ color: 'var(--primary-brand)' }}>
                ₹{content.totalPayableAmount}
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerDetailsModal;